export default "__VITE_ASSET__17ec53bb__"